module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title43"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429984003_tp01",
      "id": "toctitle41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_copyrightNotice",
    attrs: {
      "href": "#/e9781429984003_notice",
      "id": "Notice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Notice")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781429984003_ack01",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429984003_fm01",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INTRODUCTION")])])]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c01",
      "id": "toctitle4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DREAM KNIGHTS")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c02",
      "id": "toctitle5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TRICKSTER")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c03",
      "id": "toctitle6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE STREGA’S LAST DANCE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c04",
      "id": "toctitle7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AVATAR")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c05",
      "id": "toctitle8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACCIDENTALLY")]), _vm._v(", "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("LIKE A MARTYR")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c06",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE WHORES OF ONYX CITY")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c06#title10",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PROLOGUE: SEQUINED DOOM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c06#title11",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACT I: NEON-LIT NIGHTMARES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c06#title12",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACT II: HELL IS ’ROUND THE CORNER JULY 3")]), _vm._v(", "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1998")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c06#title13",
      "id": "toctitle13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACT III: PARTY’S OVER")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c07",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HEATSEEKER")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c08",
      "id": "toctitle15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TAT MASTER")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c09",
      "id": "toctitle16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HENCHMAN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c10",
      "id": "toctitle17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE ANGEL OF LONELINESS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c11",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE PICKET")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c12",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SWITCHBACK")]), _vm._v(" - "), _c('em', {
    staticClass: "i"
  }, [_vm._v("A Brief Chapter on Monsters")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c13",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AND WHAT SHALL WE CALL YOU?")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c14",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DRED")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c15",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE EDGE OF SEVENTEEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c16",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IN VINO, VERITAS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c17",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE MESSENGER")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429984003_c18",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HOUSEWORK")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c18#title26",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("I")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c18#title27",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("II")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c18#title28",
      "id": "toctitle28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("III")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c18#title29",
      "id": "toctitle29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IV.")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c18#title30",
      "id": "toctitle30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("V.")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c18#title31",
      "id": "toctitle31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("VI.")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c18#title32",
      "id": "toctitle32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("VII.")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c18#title33",
      "id": "toctitle33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("VIII.")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429984003_c18#title34",
      "id": "toctitle34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IX.")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429984003_bm01",
      "id": "toctitle35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ABOUT THE CONTRIBUTORS")])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429984003_bm02",
      "id": "toctitle39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("COPYRIGHT ACKNOWLEDGMENTS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429984003_bm03",
      "id": "toctitle40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LIST OF ILLUSTRATIONS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429984003_cop01",
      "id": "toctitle42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f2534e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429984003_toc01.vue
// module id = 69
// module chunks = 0